module.exports = __webpack_public_path__ + "img/genicon-icons8-alert.0926d2fe.svg";